import React, {useEffect} from 'react';
import styles from './styles.module.scss';
import {observer} from 'mobx-react-lite';
import {createDataTestId} from '../../../utils/dataTestId';
import {reportGeneratorsStore} from '../stores/ReportGeneratorsStore';
import FormInputs from '../componenets/ChartProcess/FormInputs';
import ChartTabs from '../componenets/ChartProcess/ChartTabs';
import {chartConfigInfo} from '../consts';
import ChartCreationSelector from '../componenets/ChartProcess/ChartCreationSelector';
import FieldSelect from '../componenets/FieldSelectDialog/FieldsSelectDialog';
import {useFieldsQuery} from '../useFieldQuery';
import {handleToggleFieldsDialog} from '../actions';
import {Flex, Scrollbar} from '@priority-software/priority-style-react';
import ChartTypeFolder from '../componenets/ChartProcess/ChartTypeFolder';
import {IChartConfig} from '../types';

const ChartGeneratorPage = observer(() => {
    const {
        currentReport,
        chartInfo,
        onSaveChartInfo,
        isFieldsDialogOpen,
        currentChartTab,
        setCurrentChartTab
    } = reportGeneratorsStore?.currentScreen;
    const {isLoadingFields, fields} = useFieldsQuery(reportGeneratorsStore?.currentScreen);
    const {nodeId} = currentReport;

    useEffect(() => {
        if (chartInfo.baseForm !== nodeId) {
            onSaveChartInfo(chartConfigInfo.baseForm as keyof IChartConfig, nodeId);
        }
    }, [nodeId]);

    return (
        <div className={styles.snowWrapper}>
            <Scrollbar>
                <div className={styles.container}>
                    <div
                        className={styles.headerContent}
                        {...createDataTestId('chart-main-page-content')}
                    >
                        <FormInputs />
                        <Flex direction="row">
                            <ChartTabs
                                chartInfo={chartInfo}
                                currentChartTab={currentChartTab}
                                setCurrentChartTab={setCurrentChartTab}
                            />
                            {chartInfo.type && <ChartTypeFolder chartInfo={chartInfo} />}
                        </Flex>
                    </div>
                    <div className={styles.contentWrapper}>
                        <ChartCreationSelector currentChartTab={currentChartTab} />
                    </div>
                    {isFieldsDialogOpen && (
                        <FieldSelect
                            isLoadingFields={isLoadingFields}
                            fields={fields?.all || []}
                            onClose={() => handleToggleFieldsDialog(false)}
                        />
                    )}
                </div>
            </Scrollbar>
        </div>
    );
});

export default ChartGeneratorPage;
